var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoShortLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 100,
    viewBox: "0 0 137 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1767 55.3146L22.4974 49.9989L43.7803 71.2621L65.0628 92.5257C57.0818 100.499 43.7799 103.157 35.7989 95.1834L14.5164 73.9202L14.5072 73.9106C9.19905 68.5949 11.8594 60.6274 17.1767 55.3146ZM6.53558 65.9464C2.42213 61.8366 0.660722 55.9889 0.614773 49.9989C0.571579 55.6308 1.97389 61.3888 6.53558 65.9464ZM6.53558 34.0514C1.97389 38.6091 0.571579 44.367 0.614773 49.9989C0.660722 44.009 2.42213 38.1613 6.53558 34.0514Z",
    fill: "url(#paint0_linear_3048_5743)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.792 4.81347C43.773 -3.16013 57.0748 -0.502038 65.0557 7.47168L22.5586 49.9287L22.4951 50L17.1748 55.3154C11.8576 60.6281 9.197 68.5954 14.5049 73.9111L6.5332 65.9473C2.41988 61.8375 9.41871e-05 56.4301 0 50C0.0459486 44.01 1.98359 38.6028 6.5332 34.0518L14.2969 26.2949C14.3645 26.2236 14.4335 26.1524 14.5039 26.082L14.5049 26.0811L14.5098 26.0771L35.792 4.81347Z",
    fill: "#1D3645"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.204 4.81412C93.2233 -3.15964 79.9214 -0.501962 71.9404 7.47179L114.506 49.9986L119.826 44.6829C125.147 39.3668 127.807 31.3931 122.487 26.0773L101.204 4.81412ZM130.468 65.9461C135.029 61.3885 136.288 55.6305 136.244 49.9986C136.198 55.9886 134.581 61.8362 130.468 65.9461ZM130.468 34.0511C134.581 38.1609 136.198 44.0086 136.244 49.9986C136.288 44.3667 135.029 38.6087 130.468 34.0511Z",
    fill: "url(#paint1_linear_3048_5743)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.472 34.0523C134.585 38.162 137.053 43.6312 137.004 49.9996C136.954 56.5952 134.585 61.838 130.472 65.9478L122.491 73.9214C122.526 73.8857 122.559 73.8472 122.593 73.8111C122.558 73.8477 122.523 73.886 122.487 73.9224L101.205 95.1861C93.2236 103.16 79.9209 100.502 71.9399 92.5279L114.505 50.0015L114.506 50.0025L114.51 49.9996L119.831 44.6841C125.151 39.368 127.811 31.3943 122.491 26.0787L130.472 34.0523Z",
    fill: "#1D3645"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3048_5743",
    x1: 68.5022,
    y1: -0.000174565,
    x2: 68.5022,
    y2: 99.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#62B5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3048_5743",
    x1: 68.5011,
    y1: -0.000500863,
    x2: 68.5011,
    y2: 99.9977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#62B5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShortLight);
export default __webpack_public_path__ + "static/media/logo-short-light.c63f98ff6019b88ce017d98f62f2a9e0.svg";
export { ForwardRef as ReactComponent };